{
  "Winner": "Winner",
  "RunnerUp": "Runner up",
  "selectAward": "select award",
  "NoCompetitors": "There are no competitors to select from yet.",
  "editDetails": "edit details",
  "CoJudgesFor": "Co-judges for ",
  "Competitors": "Competitors",
  "changeProject": "change project",
  "selectProject": "select project",
  "manage": "manage",
  "editSponsor": "edit sponsor",
  "editSupports": "edit supports",
  "edit": "edit",
  "Details": "Details",
  "DetailsPhrase1": "Is this a 1920's speakeasy? Give us some details.",
  "DetailsPhrase2": "Fuzzy signal. Stay tuned. Good things to come.",

  "NewEvent": "New Event",

  "Online": "Online",
  "HostedBy": "Hosted by: ",
  "Contact": "Contact:",
  "FreeAgents": "Free Agents",
  "Hub": "Hub",
  "based": "based",
  "SuccesfullySent": "Succesfully sent",
  "invite": "invite",
  "invites": "invites",
  "to": "to:",
  "TO": "to",
  "AlreadyAMember": "Already a member",
  "AlreadyInvited": "Already invited",
  "SendNudge": "To send them a nudge, go to your pending invites.",
  "ErrorSending": "Opps! Error sending",
  "thisEmail": "this email",
  "theseEmails": "these emails",
  "*required": "*required",
  "judgeBioNotFilled": "This judge has not filled out their bio yet.",
  "editYourBio": "edit your bio",
  "Judges": "Judges",
  "NoJudges": "No judges yet.",
  "InviteThem": "Invite them.",
  "unpublish": "unpublish",
  "unpublished": "This is unpublished ",
  "publish": "publish",

  "Participants": "Participants ",
  "seeAll": "see all",
  "inviteButton": "invite",

  "PostBoard": "Post Board",
  "speakYourMind": "speak your mind here...",
  "postButton": "post",
  "MakeItSticky": "Make it sticky",
  "boost": "boost",
  "boosts": "boosts",
  "FormerRebel": "Former Rebel",
  "HubAdmin": "Hub Admin",
  "unstick": "unstick",
  "sticky": "sticky",
  "delete": "delete",
  "ThisIsSticky": "This is sticky",
  "replyPlaceholder": "reply..",
  "reply": "reply",
  "replies": "replies",

  "RoundNotStarted": "This round has not started yet",
  "StartRound": "start this round",
  "JudgeScoringStatus": "Judge's Scoring Status",
  "closeThisRound": "close this round",
  "unpublishScores": "unpublish scores",
  "ReOpenRound": "re-open round",
  "publishScores": "publish scores",
  "onlyAdmins": "only admins can see right now",
  "seeYourScores": "see your scores",
  "round": "Round",

  "unfinished": "unfinished",
  "scored": "scored",
  "notStarted": "not started",
  "Score": "Score",

  "Awards": "Awards",
  "Sponsors": "Sponsors",
  "NoSponsors": "No sponsors yet.",
  "Supports": "Supports",
  "NoSupports": "No supports yet.",

  "SureYouWantToLeave": "Are you sure you want to leave this page? Any unsaved work will be lost!",
  "CreateAnEvent": "Create An Event",
  "AddEventName": "Add event name *",
  "To": "to",
  "SearchForVenue": "Search for venue or address",
  "OnlineOnly": "Online Only? Click here",
  "selectType": "Please select type",
  "judging?": "Will there be judging?",
  "No": "No",
  "Yes": "Yes",
  "HowManyRounds": "How many rounds will you have?",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "addDescription": "add description (max 250 characters)",
  "Note": "Note: You will be the main contact for the event. Participants may email you at ",
  "Working": "Working...",
  "Next": "Next",

  "myEventsPhrase1": "You are not attending any events yet. ",
  "myEventsPhrase2": "Events will show here when you get invited.",
  "EventsCase1": "Only you participated",
  "EventsCase1Part2": "Only you are participating",
  "EventsCase2": "You + 1 Participated",
  "EventsCase2Part2": "You + 1 Participant",
  "You": "You",
  "Participated": "Participated",
  "Participant": "Participant",
  "Event": "Event",
  "Public": "Public",
  "PastEvents": "Past Events",
  "YourEvents": "Your Events",

  "OverviewTitle": "Overview - Your Scores",
  "NotScoredYet": "not scored yet",

  "PitchRubric": "Pitch Rubric",
  "YourEvaluation": "Your evaluation:",
  "unsuccessful": "Poor",
  "needsImprovement": "Adequate",
  "moderatelySuccessful": "Good",
  "successful": "Very Good",
  "verySuccessful": "Excellent",
  "Key": "Key:",
  "Innovation": "Innovation",
  "InnovationPhrase": "Defined a product, service, or initiative that solves a critical problem.",
  "InnovationPhrase2": "Laid out a viable business model.",
  "InnovationPhrase3": "Made the case that their innovation will have significant impact.",
  "InnovationPhrase4": "Identified an addressable market and understood its size and shape.",
  "RouteToMarket": "Route to Market",
  "InnovationPhrase5": "Laid out a persuasive go-to-market strategy.",
  "InnovationPhrase6": "Showed whether it can scale and how.",
  "Resources": "Resources",
  "ResourcesPhrase1": "Presented a feasible model for going from minimum viable product to scale.",
  "ResourcesPhrase2": "Clarified who their first team needs to include and why this team can pull it off.",
  "ResourcesPhrase3": "Identified resources in the ecosystem they’ll need, and how they’ll access them.",
  "Financials": "Financials",
  "FinancialsPhrase1": "Presented a plausible cash flows model, showing where the money with come from.",
  "FinancialsPhrase2": "Laid out a way to prove this to stakeholders.",
  "FinancialsPhrase3": " Modeled scenarios for capital required, with plausible returns for investors.",
  "TotalPoints": "Total Points",
  "OutOf": "out of ",
  "TotalScore": "Total Score",
  "done": "done",
  "Overall": "Overall",
  "AverageRating": "Average Rating",
  "EditYourEvaluation": "edit your evaluation",
  "JudgingNowClosed": "Thanks for your input! Judging is now closed.",

  "backToTheEvent": "back to the event",
  "Projects": "Projects",
  "Overview": "Overview"
}
